
import React from "react";
import { Activity, CheckCircle, AlertCircle } from "lucide-react";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface SystemStatusCardProps {
  apiStatus: 'operational' | 'degraded' | 'down';
  lastChecked: string;
  uptime: number;
}

const SystemStatusCard = ({ apiStatus, lastChecked, uptime }: SystemStatusCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Activity className="h-5 w-5" />
          System Status
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center">
          <div className="flex-1">
            <div className="text-lg font-medium mb-1">API Status</div>
            <div className="flex items-center">
              {apiStatus === "operational" ? (
                <>
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  <span className="text-green-700">Operational</span>
                </>
              ) : apiStatus === "degraded" ? (
                <>
                  <AlertCircle className="h-5 w-5 text-amber-500 mr-2" />
                  <span className="text-amber-700">Degraded Performance</span>
                </>
              ) : (
                <>
                  <AlertCircle className="h-5 w-5 text-red-500 mr-2" />
                  <span className="text-red-700">System Down</span>
                </>
              )}
            </div>
          </div>
          <div className="flex-1">
            <div className="text-lg font-medium mb-1">Last Checked</div>
            <div className="text-muted-foreground">
              {lastChecked}
            </div>
          </div>
          <div className="flex-1">
            <div className="text-lg font-medium mb-1">Uptime (30 days)</div>
            <div className="flex items-center gap-2">
              <Progress value={uptime} className="h-2" />
              <span className="text-sm font-medium">{uptime}%</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SystemStatusCard;
